import * as React from 'react';
import { StyleSheet } from 'react-native';
import { Layout } from '../_primatives';
import { poallCardStyles } from '../_primatives/PoallCard';

interface QuestionCardProps { }

export const QuestionCard: React.FunctionComponent<QuestionCardProps> = (props) => {
    return (
        <Layout style={[poallCardStyles.shadow, styles.container]}>
            {props.children}
        </Layout>
    );
};



const styles = StyleSheet.create({
    container: {
        paddingVertical: 16, // match card
        paddingHorizontal: 24, // match card
        borderRadius: 0,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderColor: 'rgb(228, 233, 242)'
    }
});
